export default __webpack_public_path__ + "static/media/img-0244-australia-premium-face.549f3ec4.png";